import { render, staticRenderFns } from "./EventBooking.vue?vue&type=template&id=2c3c22e2&"
import script from "./EventBooking.vue?vue&type=script&lang=js&"
export * from "./EventBooking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports